module.exports = __webpack_public_path__ + "assets/img/37_1458.70113cdf.jpg";